package com.artvending.warden

import androidx.compose.runtime.Composable

abstract class ScreenModel {
	@Composable
	abstract fun Display(scope: Any?)
	
	abstract val page: Page?
	
	open fun enter() {}
	
	open fun exit() {}
}